<template>
  <div>
    <template v-if="show">
      <b-sidebar
        id="sidebar-right"
        title="Шинэ"
        right
        shadow
        backdrop
        v-model="showSidebar"
        width="90%"
        @change="visibleChanged"
      >
        <div class="px-3 py-2" v-if="ready">
          <h1>Тусгай зөвшөөрөл</h1>
          <Form ref="formValidate" :model="taskModel">
            <template v-for="(field, i) in fields">
              <template v-if="field.flag === 1">
                <FormItem
                  :rules="field.rule"
                  :label="field.title"
                  :prop="field.field"
                  :key="`lbl_${i}`"
                >
                  <Input
                    :placeholder="field.info"
                    v-model="$data['taskModel'][field.field]"
                  />
                </FormItem>
              </template>
              <template v-else-if="field.flag === 2">
                <FormItem
                  :rules="field.rule"
                  :prop="field.field"
                  :label="field.title"
                  :key="`lbl_${i}`"
                >
                  <Input
                    v-model="$data['taskModel'][field.field]"
                    type="textarea"
                    placeholder="..."
                  />
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else-if="field.flag == 3">
                <FormItem
                  :key="`lbl_${i}`"
                  :rules="field.rule"
                  :prop="field.field"
                  :label="field.title"
                >
                  <loc-type-cascader
                    :id.sync="$data['taskModel'][field.field]"
                    v-model="$data['taskModel'][field.field]"
                    :getParentType="true"
                    :locTypekey.sync="field.key"
                    :disabled="
                      taskModel.objectTypeId == 411 && taskModel.id != 0
                    "
                  />
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else-if="field.flag === 6">
                <template v-if="taskModel.objectTypeId == 60">
                  <template v-if="taskModel.flag1 == 9900">
                    <FormItem
                      v-if="[field.field] != 'dueStartDate'"
                      :label="field.title"
                      :prop="field.field"
                      :key="`lbl_${i}`"
                      :rules="field.rule"
                    >
                      <DatePicker
                        :value="$data['taskModel'][field.field]"
                        @on-change="
                          value =>
                            ($data['taskModel'][
                              field.field
                            ] = value.toLocaleString())
                        "
                        placeholder="Select date"
                        type="datetime"
                        style="width: 100%"
                      ></DatePicker>
                      <div class="text-muted tx-11 eddt-title-info">
                        {{ infoBuilder(field.info) }}
                      </div>
                    </FormItem>
                  </template>
                  <FormItem
                    v-else
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                  >
                    <DatePicker
                      :value="$data['taskModel'][field.field]"
                      @on-change="
                        value =>
                          ($data['taskModel'][
                            field.field
                          ] = value.toLocaleString())
                      "
                      placeholder="Select date"
                      type="datetime"
                      style="width: 100%"
                    ></DatePicker>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <FormItem
                  v-else
                  :prop="field.field"
                  :label="field.title"
                  :key="`lbl_${i}`"
                  :rules="field.rule"
                >
                  <DatePicker
                    :value="$data['taskModel'][field.field]"
                    @on-change="
                      value =>
                        ($data['taskModel'][
                          field.field
                        ] = value.toLocaleString())
                    "
                    placeholder="Select date"
                    type="datetime"
                    style="width: 100%"
                  ></DatePicker>
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else-if="field.flag === 18">
                <FormItem
                  :key="`lbl_${i}`"
                  :rules="field.rule"
                  :prop="field.field"
                  :label="field.title"
                >
                  <summernote
                    v-if="!$store.state.app.isMobile"
                    v-model="$data['taskModel'][field.field]"
                    :text="$data['taskModel'][field.field]"
                  ></summernote>
                  <Input
                    v-else
                    v-model="$data['taskModel'][field.field]"
                    type="textarea"
                  />
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else-if="field.flag === 51">
                <FormItem
                  :key="`lbl_${i}`"
                  :rules="field.rule"
                  :prop="field.field"
                  :label="field.title"
                >
                  <loctype-multiple-tag
                    v-model="$data['taskModel'][field.field]"
                    :ids.sync="$data['taskModel'][field.field]"
                    :lkey.sync="
                      field.key + '_' + $data['taskModel']['projectId']
                    "
                  ></loctype-multiple-tag>
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else-if="field.flag === 70">
                <FormItem
                  :rules="field.rule"
                  :prop="field.field"
                  :label="field.title"
                  :key="`lbl_${i}`"
                >
                  <simple-uploader
                    v-model="$data['taskModel'][field.field]"
                    :propBoxId="0"
                    :propObjectId="'0'"
                    :propObjectTypeId="$data['taskModel']['objectTypeId']"
                    @on-success="fileUploaded($event, field)"
                  >
                    <div slot="content" style="position: relative">
                      <i
                        class="ivu-icon ivu-icon-ios-cloud-upload-outline m-r-xs"
                        style="font-size: 20px; "
                      ></i>
                      <span v-if="$data['taskModel'][field.key] === ''"
                        >Энд дарж файлаа үүсгэнэ үү.</span
                      >
                      <span v-else>
                        {{ $data["taskModel"][field.key] }}
                        <span
                          style="cursor:pointer; position: absolute; right: 5px; top: 5px; padding: 0px;"
                          class="p-md"
                          @click.prevent.stop="
                            $data['taskModel'][field.field] = null;
                            $data['taskModel'][field.key] = '';
                          "
                        >
                          <i
                            class="ivu-icon ivu-icon-md-close m-t-n-md"
                            style="color:red; font-size: 16px"
                          ></i>
                        </span>
                      </span>
                    </div>
                  </simple-uploader>
                  <div class="text-muted tx-11 eddt-title-info">
                    {{ infoBuilder(field.info) }}
                  </div>
                </FormItem>
              </template>
              <template v-else>
                <div :key="`ddr${i}`">{{ field }}</div>
              </template>
            </template>
          </Form>
        </div>
        <template v-slot:footer>
          <div class="d-flex lign-items-center px-3 py-2">
            <b-button @click="onSubmit" variant="primary">
              <b-icon icon="pencil"></b-icon>Хадгалах
            </b-button>
            <!-- <b-button size="sm" @click="hide">Close</b-button> -->
          </div>
        </template>
      </b-sidebar>
    </template>
  </div>
</template>

<script>
import { getEditFields } from "@/api/taskCore";
import { getInheritedTask, postInheritedTask } from "@/api/task";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import { Form, Input, FormItem, DatePicker } from "element-ui";

import { mapActions } from "vuex";

export default {
  name: "editBase",
  components: {
    Form,
    FormItem,
    Input,
    DatePicker,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    loctypeMultipleTag: () => ({
      component: import("@/components/task/edit/components/locTypeMultipleTag"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    showSidebar: false,
    fields: [],
    ready: false,
    taskModel: {}
  }),
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    prms: {
      type: Object,
      default: () => {}
    }
    // id: {
    //   type: Number,
    //   default: () => 0
    // },
    // boxId: {
    //   type: Number,
    //   default: () => 0
    // },
    // parentId: {
    //   type: Number,
    //   default: () => 0
    // },
    // projectId: {
    //   type: Number,
    //   default: () => 0
    // },
    // objectTypeId: {
    //   type: Number,
    //   default: () => 0
    // }
  },
  //   watch: {
  //     show: function(newVal) {
  //console.log("watch here")
  //       if (newVal) {
  //         this.init();
  //       }
  //     }
  //   },
  //computed: {
  // validation() {
  //   let isValid = true;
  //   this.fields.forEach(e=>{
  //     if(e.rule.required){
  //       isValid = this.taskModel[e.field]!=null;
  //       if(this.taskModel[e.field]=="")
  //         isValid = false;
  //       if(!isValid)
  //       {
  //         isValid=false;
  //       }
  //     }
  //   })
  //   return isValid;
  // }
  //},
  mounted() {
    this.init();
    //console.log("core edit mounted");
  },
  methods: {
    ...mapActions(["handleLoading"]),
    init() {
      this.showSidebar = true;
      this.build();
    },
    build() {
      getEditFields({
        params: { objectTypeId: this.prms.objectTypeId },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.fields = res.data.fields;

          getInheritedTask({
            params: {
              id: this.prms.id,
              parentId: this.prms.parentId,
              boxId: this.prms.boxId,
              objectTypeId: this.prms.objectTypeId,
              projectId: this.prms.projectId
            },
            store: this.$store
          }).then(res => {
            this.taskModel = res.data.task;
            this.ready = true;
          });
        }
      });
    },
    infoBuilder() {},
    fileUploaded(e, field) {
      field.uv = false;
      this.$data["taskModel"][field.key] = e.uploadedName;
      this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      field.cstmFld1 = e.uploadedUrl;
    },
    onSubmit() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.handleLoading({ isLoading: true });
          postInheritedTask({
            data: { model: this.taskModel },
            store: this.$store
          }).then(res => {
            if (res.result == 1) {
              this.$emit("on-task-posted", { res });
            }
            this.handleLoading({ isLoading: false });
          });
        } else {
          //this.$Message.error("* тэмдэглэгээтэй заавал бөглөх талбаруудыг бөглөнө үү!");
          this.$bvToast.toast(
            `* тэмдэглэгээтэй заавал бөглөх талбаруудыг бөглөнө үү!`,
            {
              title: "заавал бөглөх талбар",
              autoHideDelay: 100,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            }
          );
        }
      });
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-edit-close");
      }
    }
  }
};
</script>
